import React from "react";

const PowersDuties = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Powers & Duties of its Officer & Employees</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          The powers and duties of Officers and Employees are decided by the
          Board of Directors/Managing Director in terms of service regulations.
          As per Articles of Association of HSDC there can be 11 Directors of
          the Board of Directors of HSDC. Out of these six directors are
          appointed by the State Government, three directors by National Seeds
          Corporation and two directors by grower shareholders on the basis of
          the paid-up share capital contributed by them. The Board meet once in
          every three months and atleast four such meetings are required to be
          held in a year under the provisions of law. In addition to the Board
          meetings, the Company also holds the meetings of the Shareholders
          annually.The Chairman of the Board of Directors is appointed by the
          State Govt. in accordance with the provision of Article 88(b) of the
          Articles of Association of the Company. The Managing Director of the
          Corporation is a whole time Director and is appointed by the State
          Government in pursuance of Article 89(a)(1) of the Articles of
          Association of the Company.
        </p>

        <p>
          <strong>Executives and their roles/duties :</strong>
          <br />
          There are Seven&nbsp;Divisions/Sections in the Head Office of the
          Corporation viz Production Section, Marketing Section, Engineering
          Section, Accounts Section, Company Section, Quality Section and
          Administration Section. These divisions are headed by following
          officers:
        </p>

        <ol >
          <li>
            <h6>Chief Manager Production:</h6>

            <p>
              He is overall incharge of Production, Processing, Storage and
              Inter State Marketing of all kinds of seeds being produced by the
              Corporation. He is responsible to supervise the work of Regional
              Managers/ Managers and other Production Staff and to coordinate
              with Agriculture Department and other Institutions for allocation
              of production program.
            </p>
          </li>
          <li>
            <h6>Chief Manager Marketing:</h6>

            <p>
              He is overall incharge for initiating, planning and adopting
              strategy for marketing of seeds within the State and out side the
              state. He is responsible to supervise the work of Marketing
              Officers, Asstt. Marketing Officers and other staff of Marketing
              Section.
            </p>
          </li>
          <li>
            <h6>Executive Engineer:</h6>

            <p>
              He is the Head of Engineering Division and is responsible for
              designing installation/ commissioning of Seed Processing Plants
              including procurement of Machinery and Equipment and operation/
              maintenance of the Plants, building and machinery of the
              Corporation. The basic aim of the Corporation is to provide the
              good quality seeds to the farmers of the State for this purpose
              Corporation has established six numbers processing units at
              different locations in State. He supervises the work of Asstt.
              Engineers, Jr. Engineer and other staff of Engg Section.
            </p>
          </li>
          <li>
            <h6>Chief Finance &amp; Accounts Officer:</h6>

            <p>
              The Chief Finance &amp; Accounts Officer is the Head of Accounts
              Section and internal audit section. He supervises the work of
              Sr.Finance &amp; Accounts Officer and other Accounts Staff. He is
              responsible (i) to maintain the Accounts of the Company(ii) to
              arrange funds from commercial Banks and institutions (iii) to
              executing internal audit of the corporation(iii) to clear the
              Audit Paras of PACs &amp; A.G.&nbsp;He is also looking after the
              work of PIO (RTI Act, 2005).
            </p>
          </li>
          <li>
            <h6>Company Secretary:</h6>

            <p>
              The Company Secretary is the Head of Company Section.She is
              responsible for the work relating to Company Law Matters, Board
              Meetings and Annual General Meetings. She is Working as&nbsp;1
              <sup>st</sup>&nbsp;Appellate Authority under RTI Act, 2005. She is
              also working as Chief Vigilance Officer and Presiding Officer
              under Sexual Harrassment of Women at Workplace (Prevention,
              Prohibition &amp; Redressal) Act, 2013.
            </p>
          </li>
          <li>
            <h6>Chief Manager (Personnel &amp; Administration):</h6>

            <p>
              He is over-all Incharge of Administration Section. He supervises
              the work of APO(E) and other staff of Admn. Section. He is
              responsible for all administrative, legal matters of the
              Corporation and also supervise the work of all staff of HSDC
              regarding Administration/disciplinary and legal matters. Besides
              this, the maintenance/repair of office vehicles are also looked
              after by the above officer.
            </p>
          </li>
          <li>
            <h6>Quality Control Manager:</h6>

            <p>
              He is over-all Incharge of Quality Control Section and superwise
              the quality of seed from field level to intake of raw seed,
              Processing, Packaging, Certification and Storage etc. He is also
              looking after the work of&nbsp; Vegetable Section.
            </p>
          </li>
        </ol>

        <ul>
          <li>
            The other officers/staff of HSDC assisting the above officers in the
            official work.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PowersDuties;
